export const CIP_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  ABORTED: 'ABORTED',
} as const

export const CIP_STATUS_CODES = {
  VERIFIED: 'VERIFIED',
  MANUAL_REVIEW: 'MANUAL_REVIEW',
  REJECTED: 'REJECTED',
} as const

export type CipStatus = (typeof CIP_STATUS)[keyof typeof CIP_STATUS]
export type CipStatusCode = (typeof CIP_STATUS_CODES)[keyof typeof CIP_STATUS_CODES]

export function isCIPVerified(status: string, statusCode: string): boolean {
  return status === CIP_STATUS.SUCCESS && statusCode === CIP_STATUS_CODES.VERIFIED
}

export function isCIPAborted(status: string): boolean {
  return status === CIP_STATUS.ABORTED
}

export function isCIPInManualReview(status: string, statusCode: string): boolean {
  return status === CIP_STATUS.SUCCESS && statusCode === CIP_STATUS_CODES.MANUAL_REVIEW
}

export function isCIPRejected(status: string, statusCode: string): boolean {
  return status === CIP_STATUS.FAILURE && statusCode === CIP_STATUS_CODES.REJECTED
}

export function isCIPFailure(status: string): boolean {
  return status === CIP_STATUS.FAILURE
}
